import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from "../components/Navbar";
import ImageModal from "../components/ImageModal";

const galleryItems = [
  { id: 1, image: '/gallery/gallery1.png' },
  { id: 2, image: '/gallery/gallery2.png' },
  { id: 3, image: '/gallery/gallery3.png' },
  { id: 4, image: '/gallery/gallery4.png' },
  { id: 5, image: '/gallery/gallery5.png' },
  { id: 6, image: '/gallery/gallery6.png' },
  { id: 7, image: '/gallery/gallery7.png' },
  { id: 8, image: '/gallery/gallery8.png' },
  { id: 9, image: '/gallery/gallery9.png' },
  { id: 10, image: '/gallery/gallery10.png' },
  { id: 11, image: '/gallery/gallery11.png' },
  { id: 12, image: '/gallery/gallery12.png' },
  { id: 13, image: '/gallery/gallery13.png' },
  { id: 14, image: '/gallery/gallery14.png' },
  // { id: 15, image: '/gallery/gallery15.jpg' },
  // { id: 16, image: '/gallery/gallery16.jpg' },
  // { id: 17, image: '/gallery/gallery17.jpg' },
  // { id: 18, image: '/gallery/gallery18.jpg' },
  // { id: 19, image: '/gallery/gallery19.jpg' },
  // { id: 20, image: '/gallery/gallery20.jpg' },
  // { id: 21, image: '/gallery/gallery21.jpg' },
  // { id: 22, image: '/gallery/gallery22.jpg' },
  // { id: 23, image: '/gallery/gallery23.jpg' },
  // { id: 24, image: '/gallery/gallery24.jpg' },
  // { id: 25, image: '/gallery/gallery25.jpg' }
]

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (imageSrc, imageAlt) => {
    setSelectedImage({ src: imageSrc, alt: imageAlt });
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-gray-800 to-orange-700 text-white py-32 overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,_rgba(255,255,255,0.1)_1px,_transparent_0)] bg-[size:20px_20px]"></div>
          <div className="max-w-7xl mx-auto px-4 text-center relative">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Project Gallery</h1>
              <p className="text-xl text-gray-100 max-w-3xl mx-auto">
                Explore our portfolio of world-class sports infrastructure projects across India
              </p>
            </motion.div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {galleryItems.map((item) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: true }}
                  className="group cursor-pointer"
                  onClick={() => openImageModal(item.image, `Gallery Image ${item.id}`)}
                >
                  <div className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-100">
                    <img
                      src={item.image}
                      alt={`Sports infrastructure project ${item.id}`}
                      className="w-full h-48 sm:h-56 md:h-64 object-cover transform group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Hover overlay with click hint */}
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-center">
                        <div className="bg-black/70 rounded-full p-2 w-12 h-12 mx-auto mb-2 flex items-center justify-center">
                          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                          </svg>
                        </div>
                        <p className="text-sm font-medium">Click to view</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Image Modal */}
        <ImageModal
          isOpen={selectedImage !== null}
          imageSrc={selectedImage?.src}
          imageAlt={selectedImage?.alt}
          onClose={closeImageModal}
        />
      </div>
    </>
  );
};

export default Gallery; 
